// Batch 34 · Z-8 — Disclosure checklist AI pre-mark: Continue after a stop, the stopped progress line, "Re-run all items"
// (its own confirmation and estimate). EN + AR. Merged into lib/i18n.js translations (big-file rule).
export const I18N_B34F = {
  en: {
    dc: { b34: {
      continueN: "Continue — {n} items left",
      stoppedLine: "{done} / {total} — stopped: {reason}",
      reason: { exhausted: "AI allowance used up", no_key: "no AI key issued", interrupted: "interrupted", failed: "some batches failed" },
      rerunAll: "Re-run all items",
      rerunTitle: "Re-run all items",
      rerunWarn: "Every unanswered item is asked again, including items that already have an AI suggestion: open and rejected suggestions are replaced by the new ones. Answered and scoped-out items are not asked. The units below are charged again.",
      rerunConfirm: "Re-run all items",
    } },
  },
  ar: {
    dc: { b34: {
      continueN: "متابعة — {n} بندًا متبقيًا",
      stoppedLine: "{done} / {total} — توقف: {reason}",
      reason: { exhausted: "نفدت حصة الذكاء الاصطناعي", no_key: "لم يصدر مفتاح ذكاء اصطناعي", interrupted: "انقطع التشغيل", failed: "تعذّرت بعض الدفعات" },
      rerunAll: "إعادة تشغيل جميع البنود",
      rerunTitle: "إعادة تشغيل جميع البنود",
      rerunWarn: "يُعاد سؤال كل بند غير مُجاب، بما في ذلك البنود التي لديها اقتراح من الذكاء الاصطناعي: تُستبدل الاقتراحات المفتوحة والمرفوضة بالاقتراحات الجديدة. لا تُسأل البنود المُجابة أو المستبعدة من النطاق. تُحتسب الوحدات أدناه مرة أخرى.",
      rerunConfirm: "إعادة تشغيل جميع البنود",
    } },
  },
};

export default I18N_B34F;
